import React from 'react';
import Intercom from '@intercom/messenger-js-sdk';
export default function IntercomComponent() {
  Intercom({
    app_id: 'ggthacxp',
  });
  return <div></div>;
}